import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';

import {
  fetchFeedGroupPending,
  getGroupPendingFeed
} from 'mewe/fetchers/fetch-feed';
import { Theme } from 'mewe/constants';

export let GroupFeedPendingIndexRouteBase = {
  theme: Theme.GROUP,

  model() {
    const groupId = this.paramsFor('app.group').group_id;
    this.groupId = groupId;

    // clear feed on route opening to avoid presence of already approved/rejected posts
    getGroupPendingFeed(groupId).posts.clear();

    fetchFeedGroupPending(groupId);

    let model = EmberObject.extend({
      feed: getGroupPendingFeed(groupId),
      app: this.modelFor('app'),
      appGroup: this.modelFor('app.group'),
      isPendingFeed: true,
    }).create();

    return model;
  },

  actions: {
    refetchFeed() {
      getGroupPendingFeed(this.groupId).posts.clear();

      fetchFeedGroupPending(this.currentModel.appGroup.groupId);
    },
  },
};

export default Route.extend(GroupFeedPendingIndexRouteBase);
